import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

// ============================================================
// Admin Token 管理（普通登录）
// ============================================================

export function getToken() {
  return Cookies.get(TokenKey);
}

// set admin token（Secure 仅在生产 HTTPS 下启用，本地开发 HTTP 时自动关闭）
const isSecure = location.protocol === 'https:'

export function setToken(token) {
  return Cookies.set(TokenKey, token, { secure: isSecure, sameSite: 'Lax' })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// ============================================================
// 访客会话管理（Guest Session）
// 安全说明:
//   - 访客会话的实际session token由后端通过Set-Cookie下发为HttpOnly Cookie
//   - JS无法读写HttpOnly Cookie，从而防止XSS窃取
//   - 前端仅使用 sessionStorage 存储"是否处于访客模式"的标志
//   - sessionStorage 在浏览器关闭时自动清除，不持久化
// ============================================================

const GuestSessionKey = 'isGuestSession'

// 标记当前为访客会话（在 quickLogin2024 成功后调用）
export function setGuestSessionFlag() {
  sessionStorage.setItem(GuestSessionKey, 'true')
}

// 检查是否处于访客会话模式（用于路由守卫和UI判断）
export function isGuestSession() {
  return sessionStorage.getItem(GuestSessionKey) === 'true'
}

// 清除访客会话标志（退出访客模式时调用）
export function clearGuestSessionFlag() {
  sessionStorage.removeItem(GuestSessionKey)
}

// ============================================================
// 以下为旧 Simple-Token 函数（保留用于兼容，逐步废弃）
// 新方案中后端管理HttpOnly Cookie，前端不再直接操作Simple-Token
// ============================================================

/**
 * @deprecated 新方案使用后端HttpOnly Cookie管理访客会话，前端不应再使用此函数
 */
export function getSimpleToken() {
  return Cookies.get('Simple-Token');
}

/**
 * @deprecated 新方案使用后端HttpOnly Cookie管理访客会话，前端不应再使用此函数
 */
export function setSimpleToken(token) {
  return Cookies.set('Simple-Token', token, { expires: 0.125, secure: isSecure, sameSite: 'Lax' })
}

/**
 * @deprecated 新方案使用后端HttpOnly Cookie管理访客会话，前端不应再使用此函数
 */
export function removeSimpleToken() {
  return Cookies.remove('Simple-Token')
}
